'use client';

import { motion } from 'framer-motion';
import dynamic from 'next/dynamic';
import { useState } from 'react';
import type { Dictionary } from '@/lib/i18n';
import Section from '../Section';
import StartScreen from './StartScreen';

// three.js + @react-three/fiber + @react-three/rapier (which ships a WASM binary) are heavy —
// keep them out of the main bundle and only load them once the user actually taps play.
const TowerGame = dynamic(() => import('./TowerGame'), { ssr: false });

export default function Hero({ t }: { t: Dictionary['game'] }) {
  const [playing, setPlaying] = useState(false);

  return (
    <Section className='hero !p-0 h-[calc(100dvh-80px)] relative overflow-hidden'>
      {playing ? (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6 }}
          className='absolute inset-0'
        >
          <TowerGame t={t} />
        </motion.div>
      ) : (
        <StartScreen t={t} onStart={() => setPlaying(true)} />
      )}
    </Section>
  );
}
